(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('FrequentlyAskedQuestionDetailController', FrequentlyAskedQuestionDetailController);

    FrequentlyAskedQuestionDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'FrequentlyAskedQuestion', 'CustomUser', 'Comment', 'Task', 'ProfessionalArea', 'Answer'];

    function FrequentlyAskedQuestionDetailController($scope, $rootScope, $stateParams, previousState, entity, FrequentlyAskedQuestion, CustomUser, Comment, Task, ProfessionalArea, Answer) {
        var vm = this;

        vm.frequentlyAskedQuestion = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('teJHipsterApp:frequentlyAskedQuestionUpdate', function(event, result) {
            vm.frequentlyAskedQuestion = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
